import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scn-sanction-form',
  templateUrl: './scn-sanction-form.component.html',
  styleUrls: ['./scn-sanction-form.component.css']
})
export class ScnSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/depart-enquiry/scn-sanction/scn-sanction-form/scn-sanction-form.component.ts